module.exports = __webpack_public_path__ + "static/media/photo6.85b0b3cd.jpg";